import { render, staticRenderFns } from "./EditProperty.vue?vue&type=template&id=62267910&scoped=true&"
import script from "./EditProperty.vue?vue&type=script&lang=js&"
export * from "./EditProperty.vue?vue&type=script&lang=js&"
import style0 from "./EditProperty.vue?vue&type=style&index=0&id=62267910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62267910",
  null
  
)

export default component.exports